import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../img/products/SistemaContraIncendiosNoNormalizados/NoNormalizados1.png';
import Img2 from '../img/products/SistemaContraIncendiosNoNormalizados/NoNormalizados2.png';

const SistemaContraIncendiosNoNormalizados = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center text-danger">Sistema Contra Incendios No Normalizados</h2>

      {/* Caja animada con fondo semitransparente */}
      <div className="animated-box mb-4" role="region" aria-label="Información sobre sistema no normalizado">
        <p className="mb-0 text-justify text-withe">
          Sistema no listados o equipos de presión aplicados contra incendio, opción nacional en opción Diesel y eléctricos,
          no evaluados ni aprobados por organizaciones reconocidas como: Underwriters Laboratories (UL) o Factory Mutual (FM),
          pero tratando de acercarlos lo más posible a la Norma NFPA 20 y tratando de que puedan entregar el 150 % del caudal
          de diseño, a una presión no inferior del 65% de la presión de diseño y la presión de cierre no exceda el 140% de la
          presión de diseño. <strong>Entregamos todos nuestros sistemas de acuerdo a las condiciones de diseño recibidas y listos
            para ser instalados de acuerdo con las necesidades de cada proyecto.</strong>
        </p>
      </div>

      <div className="row align-items-start mb-2">
        <div className="col-md-7">
          <p className="lead text-justify text-white">
            Sistemas adaptados para tratar de que puedan entregar el 150 % del caudal de diseño a una presión
            no inferior del 65% de la presión de diseño y la presión de cierre no excede el 140% de la presión
            de diseño.
          </p>
          <p className="lead text-justify text-white">
            Al no tener que pasar por el proceso de certificación, estos equipos suelen ser más económicos,
            pueden estar más fácilmente disponibles en el mercado, ya que no están sujetos a las restricciones
            de las certificaciones y pueden ser personalizados o adaptados a necesidades específicas sin las
            limitaciones impuestas por las normas de certificación.
          </p>
        </div>

        <div className="col-md-5">
          <div className="row g-4">
            {[Img1, Img2].map((imgSrc, idx) => (
              <div className="col-6" key={idx}>
                <img
                  src={imgSrc}
                  className="img-fluid rounded shadow-sm img-hover-zoom"
                  alt={`Sistema no normalizado imagen ${idx + 1}`}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SistemaContraIncendiosNoNormalizados;
